import { render, staticRenderFns } from "./IneligibleList.vue?vue&type=template&id=738d4c14&scoped=true"
import script from "./IneligibleList.vue?vue&type=script&lang=js"
export * from "./IneligibleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738d4c14",
  null
  
)

export default component.exports